import { render } from "./ProviderFormSidebar.vue?vue&type=template&id=2a378ff0"
import script from "./ProviderFormSidebar.vue?vue&type=script&lang=js"
export * from "./ProviderFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__